import AlbumSlideshowSolicitation from './AlbumSlideshowSolicitation';

export default AlbumSlideshowSolicitation;
